import { render } from "./template.vue?vue&type=template&id=96368bf4&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=96368bf4&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96368bf4"]])

export default __exports__